import { render, staticRenderFns } from "./demo-viewer.vue?vue&type=template&id=fafa34b8&scoped=true&"
import script from "./demo-viewer.vue?vue&type=script&lang=js&"
export * from "./demo-viewer.vue?vue&type=script&lang=js&"
import style0 from "./demo-viewer.vue?vue&type=style&index=0&id=fafa34b8&lang=less&scoped=true&"
import style1 from "./demo-viewer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafa34b8",
  null
  
)

export default component.exports